import { useTranslation } from 'react-i18next';

/**
 * Mentre es carrega una pantalla (§10.4): una versió petita del sol del splash (index.html), que
 * apareix amb un retard breu perquè les càrregues ràpides no facin pampallugues.
 */
export function Loading() {
  const { t } = useTranslation();
  return (
    <div className="loading" role="status" aria-label={t('loading')}>
      <svg className="loading-mark" viewBox="0 0 40 40" aria-hidden="true">
        <defs><linearGradient id="loading-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="var(--bt-gradient-from)" /><stop offset="1" stopColor="var(--bt-gradient-to)" /></linearGradient></defs>
        <circle cx="20" cy="17" r="9" fill="url(#loading-g)" />
        <path d="M5 30 q4 -3 7.5 0 t7.5 0 t7.5 0 t7.5 0" fill="none" stroke="var(--bt-accent)" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <span className="muted small">{t('loading')}</span>
    </div>
  );
}
